import { useState } from "react";
import { HTTP_STATUSES } from "@miplatform/constants";
import { IBidResponse } from "@miplatform/types";
import { buildSearchQuery } from "@miplatform/utils";
import { useBids } from "@mibuildweb/hooks";
import { FilterObject } from "../types";

export const useBidSearchAutocomplete = ({
  search,
}: UseBidSearchAutoCompleteProps) => {
  const [bidOptions, setBidOptions] = useState<BidSearchAutocompleteOption[]>();

  const { isLoading, getBids } = useBids();

  const getBidOptions = async () => {
    const searchQuery = buildSearchQuery(search, ["name"]);
    const filterObj: FilterObject = {
      ...searchQuery,
      not: { builderId: { type: "guid", value: null } }, // exclude area templates which have null builderId
    };

    const response = await getBids({
      filters: filterObj,
      sort: "name",
      top: 10,
    });

    if (response.status === HTTP_STATUSES.OK) {
      const options = response.data.map((bid: IBidResponse) => ({
        ...bid,
        value: bid.id,
        label: bid.name,
      }));
      setBidOptions(options);
    }
  };

  return {
    getBidOptions,
    bidOptions,
    isLoading,
  };
};

type UseBidSearchAutoCompleteProps = {
  search: string;
};

export type BidSearchAutocompleteOption = IBidResponse & {
  value: string;
  label: string;
};
